import React, { useState, useEffect } from 'react';
import {
  FormGroup, FormControl, FormHelperText
} from '@material-ui/core';
import AsyncSelect from 'react-select/async';
import { useField } from 'react-final-form-hooks';
import _ from 'lodash';

import './index.css';


const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '5px',
  textAlign: 'center',
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

const customStyles = {
  menu: (provided) => ({
    ...provided,
    padding: 0,
    zIndex: 2,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? '#FFD663' : state.isFocused ? '#fff6df' : '#FFF',
    padding: '3px 10px',
    fontSize: 14,
  }),
  control: (provided) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    outline: 'none',
    boxShadow: 'none',
    borderRadius: 3,
    minHeight: 40,
    minWidth: '100%',
    fontSize: 14,
    borderColor: 'rgba(0, 0, 0, 0.23)',
    // borderColor: state.isFocused ? "#FFD663" : "transparent",
    '&:focus': {
      borderColor: '#067ebe',
      outline: 'none',
      boxShadow: 'none',
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    overflow: 'visible',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '5px 10px',
  }),
};


export default ({
  form, name, label, hint, useSelect, preloadOptions, hidden, ...props
}) => {
  if (hidden) return null;

  const { loadOptions } = useSelect();
  const [values, setValues] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(preloadOptions);
  const field = useField(name, form);

  const onChange = (opts) => {
    setSelectedOptions(opts);
    field.input.onChange(_.map(opts, 'value'));
  };

  useEffect(() => {
    const value = _.get(field, 'input.value', []) || [];
    setValues(value.map((_id) => selectedOptions.find((opt) => opt.value === _id)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.input.value]);

  useEffect(() => {
    setSelectedOptions(preloadOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preloadOptions]);

  return (
    <FormGroup>
      <FormControl
        fullWidth
        margin="normal"
        error={field.meta.touched && field.meta.error}
        variant="outlined"
        size="small"
      >
        <AsyncSelect
          cacheOptions
          value={values}
          defaultOptions
          loadOptions={loadOptions}
          formatGroupLabel={formatGroupLabel}
          isMulti
          placeholder=""
          styles={customStyles}
          onChange={onChange}
        />
        <small className="position-absolute bg-white px-1" style={{ left: 10, top: '-10px' }}>{label}</small>
        {(field.meta.touched && field.meta.error) ? <FormHelperText>{field.meta.error}</FormHelperText> : null}
      </FormControl>
    </FormGroup>
  );
};
